const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/audit/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { auditLogsFilterSchema } from '@/components/common/settings/audit/auditLogsFilter';
import { PermissionDeniedError } from '@/lib/hooks/common/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/audit/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(auditLogsFilterSchema.catch({
    mode: 'all'
  })),
  beforeLoad: ({
    params,
    context
  }) => {
    if (!context.permissions.edit_organization) {
      throw new PermissionDeniedError('edit_organization');
    }
    if (!context.flags.auditViewEnabled) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: params.org
        }
      });
    }
    return null;
  }
});